import { useParams } from 'react-router-dom';
import { WeddingTemplateV2Workspace } from '@/components/weddingTemplatesV2/WeddingTemplateV2Workspace';

export default function WeddingTemplateV2PreviewPage() {
  const { templateKey } = useParams();

  return <WeddingTemplateV2Workspace templateKey={templateKey} />;
}
